import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalComponents from './components/_global'
import directives from './directives'
import mixins from './mixins'
import sentryPlugin from './plugins/sentry'
import multiselect from './plugins/multiselect'
import elementPlus from './plugins/element-plus'
import './versionTimer'
import './alertTimer'
import 'nprogress/nprogress.css'
import './css/tailwind.css'
import './css/main.css'
import './css/citizen-m-custom.css'
import keycloakPlugin from './plugins/keycloak'

createApp(App)
  .use(router)
  .use(store)
  .use(globalComponents)
  .use(directives)
  .use(mixins)
  .use(sentryPlugin)
  .use(multiselect)
  .use(elementPlus)
  .use(keycloakPlugin)
  .mount('#app')
